import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import { outletService } from "@/app/services/extensions/outletServiceExtended";
import type { OutletSummary } from "@/app/services/generated/outletService";

export interface IHasOutletSummariesCache {
  outlets: OutletSummariesCache;
}

// Singleton cache store
const outletSummaryCacheStore = new EntityCacheStore<OutletSummary>(
  EnumCacheEntityType.outlet,
  async () => outletService.getAllOutletSummaries()
);

// Ephemeral reader
export default class OutletSummariesCache extends EntityWithGuidKeyCache<OutletSummary> {
  constructor() {
    super(outletSummaryCacheStore, (x) => x.id);
  }
}
